// extracted by mini-css-extract-plugin
export default {"watermark":"OfficialDocuments_watermark__PI7MK"};